import { render, staticRenderFns } from "./CancelSubmitForm5.vue?vue&type=template&id=055009ab&scoped=true"
import script from "./CancelSubmitForm5.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055009ab",
  null
  
)

export default component.exports